export default "__VITE_ASSET__f626705e__"